import { render, staticRenderFns } from "./AllGamesPage.vue?vue&type=template&id=086a62f8&scoped=true"
import script from "./AllGamesPage.vue?vue&type=script&lang=js"
export * from "./AllGamesPage.vue?vue&type=script&lang=js"
import style0 from "./AllGamesPage.vue?vue&type=style&index=0&id=086a62f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a62f8",
  null
  
)

export default component.exports